
<footer class="p-4 footer text-center">
    <div class="text-big"> 
      <span  *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && mainService.contractSupport">
      <span class="m-0 f-s-16 small-mob">
        In case of any additional queries, please contact your service provider
        <b>{{planInfo && planInfo.practice_name ? planInfo.practice_name : planInfo.doctor_first_name+' '+planInfo.doctor_last_name}}</b>
        <span *ngIf="(planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"> at </span>
        <a class="text-bold" *ngIf="planInfo && (planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"
          href="tel:{{planInfo && planInfo.practice_mobile ?planInfo.practice_mobile:planInfo.doctor_phone}}">
          {{planInfo && planInfo.practice_mobile ?(planInfo.practice_mobile | phoneNumber) : (planInfo.doctor_phone | phoneNumber) ? (planInfo.doctor_phone | phoneNumber) : (planInfo.doctor_mobile | phoneNumber)}}
        </a>
      </span>
  
    </span>
    <span *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && !mainService.contractSupport">
      <span class="m-0 f-s-16 small-mob">
        Need Help? <a class="text-bold" style="color: #017A9F" href="https://www.credee.com/support" target="_blank">Click Here</a> to contact Credee Support
      </span>
    </span> &copy; {{date | date:'yyyy'}} - {{settingsData &&
      settingsData.brand?settingsData.brand.name:'Credee'}}</div>
  </footer>
  